import SetupLandingPage from '@/api/setup-landing-page'
import mainProgram from '@/api/main-program'
import subProgram from '@/api/sub-program'
import CorporatePartner from '@/api/corporate-partner'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  landingPageTypes: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_LANDING_PAGE_TYPES(state, data) {
    state.landingPageTypes = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return SetupLandingPage.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return SetupLandingPage.store(data)
  },
  uploadPhoto(context, data) {
    return SetupLandingPage.uploadPhoto(data)
  },
  imageContent(context, data) {
    return SetupLandingPage.imageContent(data)
  },
  destroy(context, id) {
    return SetupLandingPage.destroy(id)
  },
  fetchMainProgram(context) {
    return mainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchSubProgram(context, attributes = {}) {
    return subProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchCorporatePartner(context, attributes = {}) {
    return CorporatePartner.get({
      params: {
        page: -1,
        fields: {
          setup_corporate_partner_profiles:
            'cpp_id,partner_name_kh,partner_name_en'
        },
        ...attributes
      }
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.landingPageTypes.length > 0) {
      let response = await SetupLandingPage.getLandingPageType()
      context.commit('RECEIVE_LANDING_PAGE_TYPES', response.data)
    }
  }
}
